import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";

const initialState = {
  fetchLoading: false,
  isLoading: false,
  enquiryCharts: [],
};

export const fetchEnquiryCharts = createAsyncThunk(
  "fetchEnquiryCharts/enquiryChart",
  async ({ enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`enquiry-chart`);
      return {
        data: response.data.data,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const enquiryChartSlice = createSlice({
  name: "enquiryCharts",
  initialState,
  extraReducers: (builder) => {
    // ==========================

    // TODO: fetch category
    builder.addCase(fetchEnquiryCharts.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchEnquiryCharts.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.enquiryCharts = action.payload;
    });

    builder.addCase(fetchEnquiryCharts.rejected, (state, action) => {
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================
  },
});

export default enquiryChartSlice.reducer;
